import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/account',
    },
    {
      path: '/login/:schoolName?',
      name: 'login',
      props: true,
      component: () => import('./views/auth/Login.vue'),
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('./views/account/Account.vue'),
      meta: {auth: true},
    },
    {
      path: '/appointments',
      name: 'appointments',
      component: () => import('./views/appointment/Appointments.vue'),
      meta: {auth: true},
    },
    {
      path: '/appointments/calender',
      name: 'appointments/calender',
      component: () => import('./views/appointment/Calender.vue'),
      meta: {auth: true},
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import('./views/message/Messages.vue'),
      meta: {auth: true},
    },
  ],
});
